export default ({ id, data: { title } }) => ({
	title, id,
});
